<template>
    <div class="charts-summary__block">
        <div class="charts-summary__header">
            <span class="charts-summary__title">
                <slot name="title" />
            </span>
            <VTooltip>
                <span class="icon-info" />
                <template #popper>
                    <slot name="tooltip" />
                </template>
            </VTooltip>
        </div>
        <span class="charts-summary__amount">
            <slot name="amount" />
        </span>
    </div>
</template>

<script>
    export default {
        name: 'charts-summary',
        props: {
            infoRef: {
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>
    .charts-summary {
        &__block {
            background: $champagne;
            font-size: 2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            flex: 1;
            position: relative;
        }

        &__header {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        &__title {
            font-family: QuickSand-Regular, sans-serif;
        }

        &__amount {
            font-family: Nunito-ExtraBold, sans-serif;
            margin: 10px 0 0;
        }
    }
</style>
